import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const LinkOffSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default LinkOffSVG;
